import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Clock, Plus, Trash2 } from 'lucide-react';

// Paramétrage des créneaux horaires (utilisés pour affecter plusieurs formateurs sur une journée).
export const CreneauxSettings = ({ creneaux, onChange }) => {
  const list = creneaux || [];
  const update = (idx, field, value) => onChange(list.map((c, i) => i === idx ? { ...c, [field]: value } : c));
  const add = () => onChange([...list, { id: '', libelle: '', heure_debut: '09:00', heure_fin: '12:00' }]);
  const remove = (idx) => onChange(list.filter((_, i) => i !== idx));
  const duree = (c) => {
    const [h1, m1] = (c.heure_debut || '0:0').split(':').map(Number);
    const [h2, m2] = (c.heure_fin || '0:0').split(':').map(Number);
    const d = ((h2 * 60 + m2) - (h1 * 60 + m1)) / 60;
    return d > 0 ? `${Math.round(d * 100) / 100} h` : '—';
  };

  return (
    <Card data-testid="creneaux-settings">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-base"><Clock className="w-5 h-5 text-indigo-600" /> Créneaux horaires</CardTitle>
        <p className="text-xs text-slate-500">Créneaux proposés dans le planning pédagogique pour répartir plusieurs formateurs sur une même journée (le créneau « Journée » est toujours disponible).</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {list.length > 0 && (
          <div className="grid grid-cols-[1fr_88px_88px_48px_36px] sm:grid-cols-[1fr_130px_130px_70px_40px] gap-2 sm:gap-3 text-[10px] uppercase tracking-wide text-slate-400 font-semibold px-1">
            <span>Libellé</span><span>Début</span><span>Fin</span><span>Durée</span><span />
          </div>
        )}
        {list.map((c, idx) => (
          <div key={idx} className="grid grid-cols-[1fr_88px_88px_48px_36px] sm:grid-cols-[1fr_130px_130px_70px_40px] gap-2 sm:gap-3 items-center" data-testid={`creneau-row-${idx}`}>
            <Input value={c.libelle} onChange={(e) => update(idx, 'libelle', e.target.value)} placeholder="Ex : Matin" data-testid={`creneau-libelle-${idx}`} />
            <Input type="time" value={c.heure_debut} onChange={(e) => update(idx, 'heure_debut', e.target.value)} data-testid={`creneau-debut-${idx}`} />
            <Input type="time" value={c.heure_fin} onChange={(e) => update(idx, 'heure_fin', e.target.value)} data-testid={`creneau-fin-${idx}`} />
            <span className="text-xs text-slate-600 font-medium">{duree(c)}</span>
            <Button type="button" variant="ghost" size="icon" className="h-8 w-8 text-slate-400 hover:text-red-600" onClick={() => remove(idx)} data-testid={`creneau-remove-${idx}`}><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
        <Button type="button" variant="outline" size="sm" onClick={add} data-testid="creneau-add"><Plus className="w-4 h-4 mr-1" /> Ajouter un créneau</Button>
        {list.length === 0 && <Label className="block text-xs text-slate-400">Aucun créneau : seuls « Journée » et l'affectation d'un formateur unique sont possibles.</Label>}
      </CardContent>
    </Card>
  );
};
